import { Injectable, NgZone } from '@angular/core';
/*import { Http }       from '@angular/http';*/

//import 'rxjs/add/operator/map';
/*import { Subject } from 'rxjs/Subject';
import { Observable } from 'rxjs/Observable';
import { BehaviorSubject } from "rxjs/Rx";*/

import * as io from 'socket.io-client';

import { HttpClient } from "@angular/common/http";


@Injectable()
export class CommService {
    socket: any;
    private token = 'Wtsn2IWA'; // switch to help code
    private masterAPI = 'https://api.talkmath.org';
    public isConnected = false;
    public NrTeachers = 1;
    public currentRoomId = '';

    public Messages = [{ 'from': 'TalkMath', 'icon': '', 'color':'purple','data': "We're online, drop us a message!" },
    ]

    constructor(private http: HttpClient) {

    }

    /*setSocketAdress(adress: string, token: string) {
        this.socket = io(adress, { query: { token: token }});//'http://89.255.236.102:' + adress);   
    }*/

    setSocketAdress(adress: string, path: string, token = '')
    {
    console.log('setting socket address. adr: ' + adress + ', path: ' + path)
    this.socket = io(adress, {
        path: path,
        reconnection: true,
        reconnectionDelay: 1000,
        reconnectionDelayMax : 5000,
        reconnectionAttempts: Infinity,
        query : { token: token }
      });//'http://89.255.236.102:' + adress);
    }

    generateRoomName() {
        return new Date().toLocaleString();
    }

    CurrentRoom = {}

    globCurrentRoomId = '';
    globCurrentRoomName = '';

    globalSetCurrentRoom(room: any, roomId='') : void {
        this.globCurrentRoomId = room.name;
        this.globCurrentRoomName = room.id;
    }

    joinDefault() {
        this.join({'name':'General','id':'idGeneral'})
      }
    
      join(room: any): void {
    
        let id = room.name;
    
        let roomName = room.id;

        if(this.currentRoomId != "")
            this.socket.emit('unsubscribe', this.globCurrentRoomId);
    
        this.socket.emit('subscribe',id);
        this.globalSetCurrentRoom(room)
      }

    connectRoom() {
        this.http.get(this.masterAPI + '/v20/getAdress?code=' + this.token).subscribe(data => {
            // Read the result field from the JSON response.
            console.log(data);

            //if (data.length == 3) {
            if (data['status'] == 'ok') {
                var address = data['address'];
                console.log('Address: ' + address);

                let pos = address.substring(5).indexOf(':') + 5;
                let port = ""
                for (let i = pos + 1; i < pos + 5; i++)
                    port += address[i]
                // replace by api-code

                let path = '/v20/socket/' + port
                this.setSocketAdress(this.masterAPI, path, this.token);
                
                this.isConnected = true;
                console.log('communication is established');

                let dataGuest = { name: 'You', role: 'student', icon: '' };
                this.socket.emit('setGuestUserData', dataGuest);

                setTimeout(function () {
                    this.joinDefault();
                }.bind(this), 300);
                
                //this.socket.emit('connectionLobby');

                // create new room and connect to this
            }
            else if (data['status'] == 'error') {
                console.log('error');
            }
        });
    }

    public startChat() {

        var roomName = this.generateRoomName();
                var newRoomDetails = { name: roomName }
                this.socket.emit('createChannel', newRoomDetails);

                // delay a bit
                setTimeout(function () {
                    this.socket.emit('subscribe', roomName);
                }.bind(this), 300);
                

                this.socket.on('event', function (data: Object) {
                    console.log('Event received: ' + data)
                    var id = "-1";
                    if ('id' in data)
                        id = data['id'];
                    
                    //this.messageAdd(new message(data['type'], data['from'], data['data'], data['room'], data['time'], data['icon'], data['color'], id));
                    var icon = '';
                    var color = 'purple';
                    if ('icon' in data)
                        icon = data['icon'];

                    if ('color' in data)
                        color = data['color'];

                    this.Messages.push({ 'from': data['from'], 'icon': icon, 'color': color, 'data': data['data'] });
                    
                    //this.updateMathJax();
                    // render html

                    // callbacks
                    //this.appComponent.chatbar1.update();

                }.bind(this));

                this.socket.on('lobbyData', function (data: any) {//, userData: any) {

                    this.NrTeachers = data['nrTeachers'];
                    console.log('Nr teacher retrieved: ' + this.NrTeachers);

                }.bind(this));
    }
        
    public sendMessage(name: string, email: string, message: string) {
        
        // do a blind send to admin room
        if (this.isConnected == true) {
            var n = name;
            if (name != "") {
                message += ", " + name;
            }
            if (email != "")
                message += ", " + email;
            this.socket.emit('event', { 'data': message, 'from': n, 'type': 'message', 'room': 'General' });
            console.log('message sent.');
        }
    }
}
